export enum RingStates {
  anyTime = 'anyTime',
  noAnswer = 'noAnswer',
  busy = 'busy',
  dnd = 'dnd',
  unreachable = 'unreachable',
}
